<app-abandon-accounts
  (noContinue)="closePopin()"
  (yesAbandon)="abandon()"
  [show]="isPopinOpen"
></app-abandon-accounts>
<app-connecting-accounts-loader
  *ngIf="selectingAccounts"
  [currentBank]="selectedBank"
  [isTestBankConnector]="isTestBankConnector"
  [count]="countSelectedBank"
>
</app-connecting-accounts-loader>

<div
  *ngIf="accountsSelectionForm && !selectingAccounts"
  class="w-full max-w-600px d-flex flex-col justify-center items-center"
>
  <div class="d-flex flex-col justify-center items-center text-center">
    <img *ngIf="!isTestBankConnector" [src]="selectedBank.logo" alt="selected bank logo" class="w-78px" />
    <img
      *ngIf="isTestBankConnector"
      src="/assets/images/test_bank_connector.png"
      alt="test bank connector logo"
      class="w-78px"
    />
    <h1 class="font-20 font-md-24 font-lg-26">
      {{ 'select_accounts_title' | translate }}
    </h1>
    <p class="font-13 font-md-15" [innerHTML]="'select_accounts_intro' | translate "></p>
  </div>

  <form
    (ngSubmit)="submit()"
    [formGroup]="accountsSelectionForm"
    class="d-flex flex-col justify-center items-center my-3 max-w-600px w-full"
  >
    <ul class="w-full list-none p-0">
      <li
        *ngFor="let account of foundAccounts; index as i"
        class="border-solid border-0 border-verylightgray"
        [class.border-b-1]="i < foundAccounts.length - 1"
      >

      <label style="cursor: pointer; padding-top: 30px; padding-bottom: 30px; margin: auto; display: flex; align-items: center; justify-content: space-between;" [for]="account.id">
        <div style="display: flex; align-items: center; margin-right: 50px;">
        <input
        [formControlName]="account.id"
        [id]="account.id"
        class="form-check-input"
        type="checkbox"
        [(ngModel)]="account.checked"
        (ngModelChange)="changed()"
        style="margin-right: 16px; cursor: pointer;"
        />
        <div style="display: flex; flex-direction: column;">
          <span class="font-13 font-md-15 font-lg-17 font-bold">{{ account.name }}</span>
          <input
          style="width: 230px; margin-top: 8px;"
          *ngIf="isTestBankConnector && account.iban"
          class="form-check-input text"
          [formControlName]="account.iban"
          [id]="account.iban"
          [value]="account.iban"
          (keyup)="setIBAN($event, i)"
          [placeholder]="'select_accounts_iban' | translate"
          class="w-66 p-2"
          appSpaceRemover
          appUpperCase
          pattern="[A-Z0-9]{15,32}"
          />
          <span *ngIf="!isTestBankConnector && account.iban" style="display: block; margin-top: 8px">
            {{ account.iban | spaceSeparator: 4 }}
          </span>
        </div>
      </div>
        <span class="font-13 font-md-15 font-lg-17 font-bold">
          {{ account.balance | currency: account.currency : 'symbol' : '1.2-2' : 'fr' }}
        </span>
      </label>
      </li>
    </ul>

    <div *ngIf="moreThanOneAccount" class="notice mt-10">
      <img
        class="self-center w-78px w-md-100px"
        src="../../../../../assets/images/svg/info_circle.svg"
        alt="info circle"
      />

      <div class="ml-6 text-left">
        <p [innerHTML]="'select_accounts_tips' | translate" class="font-14 font-md-16"></p>
      </div>
    </div>

    <button
      [disabled]="!accountsSelectionForm.valid"
      class="btn bg-primary rounded-full px-5 mt-10"
      type="submit"
    >
      {{ 'common_continue' | translate }}
    </button>
  </form>

  <a (click)="openPopin()" class="text-dark mt-5 font-14 font-md-15" role="button">{{
    'select_accounts_abandon' | translate
  }}</a>
</div>
